import { api } from "../../utils/api"

export const StatusEmailUser = async (id: string) => {
    try {
        const res = await api.get(`/auth-user/status-email-user/${id}`);
        console.log(res.data)
        return res.data.statusAuthEmail.verified;
    } catch (error) {
        console.error("Error confirm:", error);
        throw error;
    }
}

export const ResendConfirmEmailUser = async (verificationToken: string) => {
    try {
        const res = await api.get(`/auth-user/resend-verify-email/${verificationToken}`);
        console.log(res.data)
        return res.data.message;
    } catch (error) {
        console.error("Error confirm:", error);
        throw error;
    }
}